import {createStore} from 'vuex'

export default createStore({
    state: {
        user: JSON.parse(sessionStorage.getItem('user') || 'null'),
        isLoading: false,
        msisdn: sessionStorage.getItem('msisdn') || undefined,
        brandConfig: JSON.parse(sessionStorage.getItem('brandConfig') || 'null'),
        productId: (() => { const v = sessionStorage.getItem('productId'); return (v && v !== 'null' && v !== 'undefined') ? v : undefined; })(),
        selectedLanguageId: sessionStorage.getItem('selectedLanguageId') || null,
    },
    mutations: {
        setUser(state, user) {
            state.user = user
            sessionStorage.setItem('user', JSON.stringify(user))
        },
        setIsLoading(state, isLoading) {
            state.isLoading = isLoading
        },
        setMsisdn(state, msisdn) {
            state.msisdn = msisdn
            sessionStorage.setItem('msisdn', msisdn)
        },
        setBrandConfig(state, brandConfig) {
            state.brandConfig = brandConfig
            sessionStorage.setItem('brandConfig', JSON.stringify(brandConfig))
        },
        setProductId(state, productId) {
            state.productId = productId
            if (productId === null || productId === undefined) {
                sessionStorage.removeItem('productId')
            } else {
                sessionStorage.setItem('productId', String(productId))
            }
        },
        setSelectedLanguageId(state, languageId) {
            state.selectedLanguageId = languageId
            if (languageId) sessionStorage.setItem('selectedLanguageId', languageId)
            else sessionStorage.removeItem('selectedLanguageId')
        }
    },
    actions: {},
    modules: {}
})
